import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { getCustomerList, setError } from './store/entities/customers'
import { setNewToken } from './store/entities/user'
import { globalViewText, isSuperFeedView } from './utilities/config'
import { resolveLandingPath } from './utilities/landingPage'
import { THREAT_INTEL_CUST_LICENSE_CODE, THREAT_INTEL_CUST_VALID_PATHS } from './utilities/threatIntelCustomerUtils'
import UserLicenseDetails from './components/UserLicenseDetails'
import TenantManagement from './components/TenantManagement'
import { loginIfExisting } from './store/entities/user'
import { userIsAuthenticated, userIsNotAuthenticated, userIsPixmAdmin } from './auth'
import Navbar from './components/navbar'
import Login from './components/Login'
import Incidents from './components/incidents'
import IncidentDetails from './components/incidentDetails'
import LicenseManagement from './components/licenseManagement'
import Deployment from './components/deployment'
import Settings from './components/settings'
import AddOrganization from './components/AddOrganization'
import UpdateOrganization from './components/UpdateOrganization'
import AddAdmin from './components/AddAdmin'
import AddWhitelistDomain from './components/AddWhitelistDomain'
import AddBlacklistUrl from './components/AddBlacklistUrl'
import SocIntegration from './components/SocIntegration'
import Dashboard from './components/Dashboard'
import SocDetails from './components/SocDetails'
import ThreatIntelSOC from './components/ThreatIntelSOC'
import ThreatIntelligence from './components/ThreatIntelligence'

import { CookieUtils } from './utilities/cookies'
//import './App.css'
import 'react-toastify/dist/ReactToastify.css'
import { decodeToken } from './utilities/decodeToken'
import AdvancedSettings from './components/AdvancedSettings'
import AddWhitelistUrl from './components/AddWhitelistUrl'
import AddEditBrandPolicies from './components/AddEditBrandPolicies'
import AddThreatIntel from './components/AddThreatIntel'
import ThreatIntelFeed from './components/ThreatIntelFeed'
import ThreatIntelDetails from './components/ThreatIntelDetails'
import SuperFeed from './components/super-feed/SuperFeed'
import SuperFeedDetails from './components/super-feed/SuperFeedDetails'
import AddEditEmailDomain from './components/AddEditEmailDomain'
import ThreatIntelCustomerRedirect from './components/ThreatIntelCustomerRedirect';
import CredentialMonitoring from './components/credential-monitoring/CredentialMonitoring'
import RiskProfileDetails from './components/credential-monitoring/RiskProfileDetails'
import UpdateAdmin from './components/UpdateAdmin'
import DeviceDetails from './components/LicenseManagement/DeviceDetails'
import UserDetails from './components/LicenseManagement/UserDetails'
import Governance from './components/Governance/Governance'
import GovernanceEditor from './components/Governance/GovernanceEditor'
import DataControlEntity from './components/DataControlEntity/DataControlEntity'
import PolicyViolations from './components/PolicyViolations/PolicyViolations'
import IncidentFeed from './components/IncidentFeed/IncidentFeed'

const ProtectedIncidents = userIsAuthenticated(Incidents)
const ProtectedIncidentDetails = userIsAuthenticated(IncidentDetails)
const ProtectedLicenseManagement = userIsAuthenticated(LicenseManagement)
const ProtectedDeployment = userIsAuthenticated(Deployment)
const ProtectedSettings = userIsAuthenticated(Settings)
const ProtectedUserLicenseDetails = userIsAuthenticated(UserLicenseDetails)
const RedirectedLogin = userIsNotAuthenticated(Login)
const ProtectedTenantManagement = userIsAuthenticated(TenantManagement)
const ProtectedAddOrganization = userIsAuthenticated(AddOrganization)
const ProtectedUpdateOrganization = userIsAuthenticated(UpdateOrganization)
const ProtectedAddAdmin = userIsAuthenticated(AddAdmin)
const ProtectedAddWhitelistDomain = userIsAuthenticated(AddWhitelistDomain)
const ProtectedAddBlacklistUrl = userIsAuthenticated(AddBlacklistUrl)
const ProtectedSocIntegration = userIsAuthenticated(SocIntegration)
const ProtectedAdvancedSettings = userIsAuthenticated(AdvancedSettings)
const ProtectedAddWhitelistUrl = userIsAuthenticated(AddWhitelistUrl)
const ProtectedAddEditBrandPolicies = userIsAuthenticated(AddEditBrandPolicies)
const ProtectedAddThreatIntel = userIsAuthenticated(AddThreatIntel)
const ProtectedAddEditEmailDomain = userIsAuthenticated(AddEditEmailDomain)
const ProtectedThreatIntelFeed = userIsAuthenticated(ThreatIntelFeed)
const ProtectedThreatIntelDetails = userIsAuthenticated(ThreatIntelDetails)
const ProtectedSuperFeed = userIsAuthenticated(SuperFeed)
const ProtectedSuperFeedDetails = userIsAuthenticated(SuperFeedDetails)
const ProtectedThreatIntelSOC = userIsAuthenticated(ThreatIntelSOC);
const ProtectedThreatIntelligence = userIsAuthenticated(ThreatIntelligence);
const ProtectedCredentialMonitoring = userIsAuthenticated(CredentialMonitoring);
const ProtectedRiskProfileDetails = userIsAuthenticated(RiskProfileDetails);
const ProtectedDeviceInfoDetails = userIsAuthenticated(DeviceDetails);
const ProtectedUserInfoDetails = userIsAuthenticated(UserDetails);
const ProtectedUpdateAdmin = userIsAuthenticated(UpdateAdmin);
const ProtectedGovernance = userIsPixmAdmin(Governance);
const ProtectedGovernanceEditor = userIsPixmAdmin(GovernanceEditor);
const ProtectedDataControlEntity = userIsPixmAdmin(DataControlEntity);
const ProtectedPolicyViolations = userIsPixmAdmin(PolicyViolations);
// Incident Feed is PixmAdmin-only, same gate as Governance and Policy Violations — the
// two sibling screens built from the same wireframe (PIXMC-6521).
const ProtectedIncidentFeed = userIsPixmAdmin(IncidentFeed);

class App extends Component {

  state = {
    custId: null,
    userRole: null,
    customersRendered: false,
    isGlobalView: false
  }

  // init() {
  //   // let currentToken = CookieUtils.get("token"); 
  //   // if(currentToken) {
  //   //   let decodedToken = decodeToken(currentToken);
  //   //   localStorage.setItem("customer_domain" , decodedToken["domain"])
  //   // } else {
  //   //   let domain = window.location.hostname.split(".")[0];
  //   //   let BASE_URL = process.env.REACT_APP_BASE_WHITELIST_URL.replace("<DOMAIN>", domain );
  //   //   window.location.replace(`${BASE_URL}/product/login.html?u=${process.env.REACT_APP_API_BASE_URL}&b=${process.env.REACT_APP_BASE_WHITELIST_URL}&s=${process.env.REACT_APP_REGISTER_NEW_URL}`);
  //   // }
  //   // this.props.loginIfExisting()
  // }

  componentDidMount() {
    // window.onload = () => {
    //   this.init();
    // }
    try {
      let currentToken = CookieUtils.get("token"); 
      if(currentToken) {
        let decodedToken = decodeToken(currentToken);
        localStorage.setItem("customer_domain" , decodedToken["domain"])
      } else {
        let domain = window.location.hostname.split(".")[0];
        let BASE_URL = process.env.REACT_APP_BASE_WHITELIST_URL.replace("<DOMAIN>", domain );
        window.location.replace(`${BASE_URL}/product/login.html?u=${process.env.REACT_APP_API_BASE_URL}&b=${process.env.REACT_APP_BASE_WHITELIST_URL}&s=${process.env.REACT_APP_REGISTER_NEW_URL}`);
      }
      this.props.loginIfExisting()
      if (CookieUtils.get("token")) {
        // this.fetchCustomers();
        this.props.loadCustomers();
      }
    }catch(error){
      console.error(error);
    }

  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {

      let newState = {}
      if (this.props.userRole) {
        // this.setState({
        //   userRole: this.props.userRole
        // })
        newState["userRole"] = this.props.userRole
      }
      if (this.props.selectedCustomer) {
        // this.setState({
        //   custId: this.props.selectedCustomer.id
        // })
        newState["custId"] = this.props.selectedCustomer.id
      }
      if (this.props.selectedCustomer && this.props.selectedCustomer.organizationName === globalViewText) {
        newState["isGlobalView"] = true
      }
      this.setState(newState);
    }
  }

  // fetchCustomers = async () => {
   
  // //  try{
  // //   const customers = await axiosInstance.get(`${process.env.REACT_APP_API_BASE_URL}/portal/customers`);
  // //   this.props.loadCustomers(customers.data , true , this.props.userRole);
  // //  } 
  // //  catch(error){
  // //     console.log(error);
  // //     this.props.setError("could not load customer details!!");
  // //     this.props.loadCustomers({} , true , this.props.userRole);
  // //  }
    
    
  // }

  renderBodyCompoent = (Body, props, applyBodyStyle) => (
    <Body {...props} />
  )

  getDefaultPath(userRole, licenseType, selectedCustomer, isGlobalView) {
    // D-13 (PIXMC-6521): a persona may be configured, per environment, to land somewhere
    // other than the historical default via REACT_APP_LANDING_MENU_<ROLE>.
    // resolveLandingPath returns null for blank / absent / unknown / not-permitted — and
    // for every case that would otherwise cause a redirect loop — so with all three vars
    // blank the body below runs exactly as it did before this change.
    const configuredPath = resolveLandingPath({
      userRole,
      licenseType,
      selectedCustomer,
      isGlobalView,
      isSuperFeedView: isSuperFeedView(selectedCustomer?.organizationName),
    })
    if (configuredPath) {
      return configuredPath
    }

    if (userRole === 'TenantAdmin') {
      return '/tenant-admin';
    }

    // Redirect to SOC integration if the user is a CustomerAdmin with Exclusive Threat Intelligence Access
    if (userRole === 'CustomerAdmin' && licenseType === THREAT_INTEL_CUST_LICENSE_CODE) {
      return '/threat-intel';
    }
    return isGlobalView ? '/tenants/' : `/customers/${selectedCustomer.id}/incidents`;
  }

  render() {
    if (!this.state.userRole) {
      return null
    }

    if (this.state.userRole !== 'TenantAdmin' && !this.props.selectedCustomer) {
      return null
    }


    return (
      <>
        <div className="d-flex flex-row" style={{backgroundColor:'#f7f7f7'}}>
          <ToastContainer />
          <div className="d-flex flex-column ml-auto w-100 backgroundStyle">
            <BrowserRouter>
              <Navbar />
              {/**Redirect to Threat Intelligence SOC-integration if customer has only Threat Intelligence access */}
              <ThreatIntelCustomerRedirect userRole={this.state.userRole} licenseType={this.props.licenseType} />

              {/* <LoaderWrapper loading={this.props.loading} waitForData={false}> */}
              <Switch>

                <Route
                  exact
                  path="/"
                  render={() => {
                    return <Redirect to={this.getDefaultPath(this.state.userRole, this.props.licenseType, this.props.selectedCustomer, this.state.isGlobalView)} />
                  }}
                />

                <Route
                  exact
                  path= "/tenants/:param1/:param2/incidents/:param3"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentDetails, props, true)
                  }
                />
                <Route
                  exact
                  path= "/customers/:param1/incidents/:param3"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentDetails, props, true)
                  }
                />
                <Route
                  path="/customers/:id/incidents"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidents, props, true)
                  }
                />
                <Route
                  path="/tenants/:id/incidents"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidents, props, true)
                  }
                />

                <Route
                  exact
                  path="/tenant-admin/update-organization"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedUpdateOrganization, props, false)
                  }
                />

                <Route
                  exact
                  path="/tenant-admin/add-admin"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddAdmin, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/settings/add-admin"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddAdmin, props, false)
                  }
                />

                <Route
                  exact
                  path="/advanced-settings/add-pixm-admin"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddAdmin, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/settings/add-whitelist-domain"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddWhitelistDomain, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/settings/add-whitelist-url"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddWhitelistUrl, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/settings/add-blacklist-url"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddBlacklistUrl, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/settings/add-edit-email-domain"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddEditEmailDomain, props, false)
                  }
                />

                <Route
                  path="/customers/:id/license-management"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedLicenseManagement, props, false)
                  }
                />
                <Route
                  path="/tenants/:id/license-management"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedLicenseManagement, props, false)
                  }
                />

                <Route
                  path="/customers/:id/deployment"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedDeployment, props, false)
                  }
                />
                <Route
                  path="/tenants/:id/deployment"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedDeployment, props, false)
                  }
                />

                <Route
                  exact
                  path="/tenant-admin/add-organization"
                  render={(props) => this.renderBodyCompoent(ProtectedAddOrganization, props, false)}
                />

                <Route
                  exact
                  path="/customers/:customerId/device/:deviceId"
                  render={(props) => this.renderBodyCompoent(ProtectedDeviceInfoDetails, props, false)} />

                <Route
                   exact  
                  path="/tenants/:tenantId/:customerId/device/:deviceId"  
                  render={(props) => this.renderBodyCompoent(ProtectedDeviceInfoDetails, props, false)} />  

                <Route  
                  exact  
                  path="/customers/:customerId/user/:userId"  
                  render={(props) => this.renderBodyCompoent(ProtectedUserInfoDetails, props, false)} />  

                <Route  
                  exact  
                  path="/tenants/:tenantId/:customerId/user/:userId"  
                  render={(props) => this.renderBodyCompoent(ProtectedUserInfoDetails, props, false)} />  

                <Route  
                  exact
                  path="/customers/:param1/licensemanagement/:param3"
                  render={(props) => this.renderBodyCompoent(ProtectedUserLicenseDetails, props, false)} />

                <Route
                  exact
                  path="/tenants/:param1/:param2/licensemanagement/:param3"
                  render={(props) => this.renderBodyCompoent(ProtectedUserLicenseDetails, props, false)} />

                <Route
                  path="/customers/:id/settings"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedSettings, props, false)
                  }
                />

                <Route
                  exact
                  path="/tenant-admin"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedTenantManagement, props, false)
                  }
                />

                <Route
                  exact
                  path="/soc-integration"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedSocIntegration, props, false)
                  }
                />

                <Route
                  exact
                  path="/advanced-settings/add-edit-brandpolicy"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddEditBrandPolicies, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/governance"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedGovernance, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/governance/edit"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedGovernanceEditor, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/policy-violations"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedPolicyViolations, props, false)
                  }
                />

                {/* Incident Feed — tabs are path segments (PIXMC-6442 §6.5). The
                    bare path redirects to the Overview inside the component rather than
                    falling through to the catch-all below.

                    Both prefixes: unlike Governance and Policy Violations this screen IS
                    available in Global View, because both new endpoints implement the
                    r=M branch. */}
                <Route
                  exact
                  path="/customers/:id/incident-feed"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentFeed, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/incident-feed/:tab"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentFeed, props, false)
                  }
                />

                <Route
                  exact
                  path="/tenants/:id/incident-feed"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentFeed, props, false)
                  }
                />

                <Route
                  exact
                  path="/tenants/:id/incident-feed/:tab"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedIncidentFeed, props, false)
                  }
                />

                <Route
                  exact
                  path="/data-controls-entity"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedDataControlEntity, props, false)
                  }
                />

                <Route
                  exact
                  path="/advanced-settings"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAdvancedSettings, props, false)
                  }
                />

                <Route
                  exact
                  path="/advanced-settings/update-pixm-admin"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedUpdateAdmin, props, false)
                  }
                />

                <Route
                  exact
                  path="/threat-intel-feed"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedThreatIntelFeed, {props, context : "threat-intel-feed"}, false)
                  }
                />

                <Route
                  exact
                  path="/threat-intel-feed/:id"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedThreatIntelDetails, props, false)
                  }
                />

                <Route
                  exact
                  path= "/tenants/:param1/:param2/threat-intel/:param3"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddThreatIntel, props, true)
                  }
                />

                <Route
                  exact
                  path= "/customers/:param1/threat-intel/:param3"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedAddThreatIntel, props, true)
                  }
                />
            
                <Route
                  exact
                  path="/super-feed"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedSuperFeed, props, false)
                  }
                />

                <Route
                  exact
                  path="/super-feed/:id"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedSuperFeedDetails, props, false)
                  }
                />

                <Route
                  exact
                  path="/threat-intel"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedThreatIntelligence, props, false)
                  }
                />

                <Route
                  exact
                  path="/customers/:id/risk-profiles"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedCredentialMonitoring, props, false)
                  }
                />
                <Route
                  exact
                  path="/customers/:id/risk-profiles/:userId"
                  render={(props) =>
                    this.renderBodyCompoent(ProtectedRiskProfileDetails, props, false)
                  }
                />


                <Route
                  exact
                  path="*"
                  render={() => {
                    return <Redirect to={this.getDefaultPath(this.state.userRole, this.props.licenseType, this.props.selectedCustomer, this.state.isGlobalView)} />
                  }}
                />

              </Switch>
              {/* </LoaderWrapper> */}
            </BrowserRouter>
          </div>
        </div>
        {/* {this.props.statusCode && <ModalPopup statusCode={this.props.statusCode} msg={this.props.userMsg}/> } */}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  loading: state.entities.customers.loading,
  orgList: state.entities.customers.list,
  userToken: state.entities.user.token,
  userRole: state.entities.user.roles,
  customerFlag: state.entities.customers.createCustomerFlag,
  userMsg: state.entities.customers.userMsg,
  statusCode: state.entities.customers.statusCode,
  domain : state.entities.user.domain,
  licenseType: state.entities.customers.licenseType
})

const mapDispatchToProps = (dispatch) => ({
  loginIfExisting: () => dispatch(loginIfExisting()),
  loadCustomers: () => dispatch(getCustomerList()),
  setError: (error) => dispatch(setError(error)),
  setNewToken: () => dispatch(setNewToken())
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
